<template>
  <div class="container fluid">
    <div class="row">
      <div class="page-content" id="behaviour" style="display: block;">
        <div style="background-color: #fff">
          <section class="container-fluid topPDF" style="padding: 20px 25px">
            <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 40px;
          ">
              <span style="margin: 10px 0 0px">
                <h1 class="pmaps-color" style="
                  font-style: normal;
                  font-weight: 700;
                  font-size: 60px;
                  color:#7c68ee;
                  word-break: break-word;
                  background: none;
                ">
                  {{ this.BasicInfoData?.testName
                    ? this.BasicInfoData?.testName
                    : "NA"
                  }}
                </h1>
                <span style="
                border: 2px solid #7b68ee;
                width: 100%;
                display: block;
                margin: 15px 0;
              "></span>
                <h2 style="font-style: normal; font-weight: 500; font-size: 30.4979px">
                  {{ this.BasicInfoData?.companyName
                    ? this.BasicInfoData?.companyName
                    : "NA"
                  }}
                </h2>
              </span>
              <span>
                <img src="../../public/dashboard-assets/images/M7/Proctor-header-img.png" width="400" alt="" />
              </span>
            </div>
          </section>
          <section style="padding: 18px 25px">
            <h4 style="
            text-transform: uppercase;
            font-weight: 700;
            font-size: 24px;
            margin-bottom: 23px;
            font-style: normal;
            color: #7c68ee;
          ">Behavioural Report </h4>
            <div class="Recomended_icon_btn mb-2" v-if="this.recommendationValue">
              <div class="Assessment_Recommended_new" :class="getRecommendationClass()"
                style="display: flex;align-items: center;flex-wrap: wrap;flex-direction: row;">
                <img :src="this.recommendation_img" style="width:25px;height:25px;" alt="" />
                <p style="font-size: 20px;margin-left: 2px;  line-height: 1; padding-bottom: 0px; margin-bottom: 0;">
                  {{ this.recommendationValue }}
                </p>
              </div>
            </div>
            <!-- basic info -->
            <div style="margin-top: 25px">
              <span style="
              font-style: normal;
              font-weight: 700;
              font-size: 20px;
              letter-spacing: 0.008em;
              text-transform: uppercase;
              color: #666666;
            ">basic info</span>
              <p style="
              font-style: italic;
              font-weight: 400;
              font-size: 14px;
              padding-top: 15px;
              color: #666666;
            "> From the test results it seems that, the candidate may be considered for the further evaluation in the
                recruitment process. </p>
              <div class="row" style="
              border: 1px solid rgba(0, 0, 0, 0.17);
              border-radius: 8px;
              margin: 25px 0;
              padding: 15px;
            ">
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Candidate Name</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.BasicInfoData?.name ? this.BasicInfoData?.name : "NA" }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Candidate ID</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.candidateId ? this.candidateId : "NA" }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Email</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.BasicInfoData?.emailAddress
                      ? this.BasicInfoData?.emailAddress
                      : "NA"
                    }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Exam Started</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ moment(this.BasicInfoData?.examStarted).format(
                      "DD/MM/YYYY, HH:mm:ss a"
                    )
                    }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Invited By</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.BasicInfoData?.invitedBy
                      ? this.BasicInfoData?.invitedBy
                      : "NA"
                    }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Test Name</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.BasicInfoData?.testName
                      ? this.BasicInfoData?.testName
                      : "NA"
                    }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Language</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.BasicInfoData?.language
                      ? this.BasicInfoData?.language
                      : "NA"
                    }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Time Taken (in min)</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.BasicInfoData?.timeTakenInMins
                      ? this.BasicInfoData?.timeTakenInMins
                      : "NA"
                    }}
                  </h6>
                </div>
                <div class="col-md-4" style="padding-bottom: 20px; flex: 0 0 auto; width: 33.33333333%">
                  <label style="font-weight: 400; font-size: 14px; color: #7b818d">Total Question Attempted</label>
                  <h6 style="font-weight: 800; font-size: 14px; color: #292e34">
                    {{ this.BasicInfoData?.totalQuestionAttempted
                      ? this.BasicInfoData?.totalQuestionAttempted
                      : "NA"
                    }}
                  </h6>
                </div>
              </div>
            </div>
            <div style="margin-top: 25px ;page-break-after: always;page-break-before: always;">
              <div style="display: flex; justify-content: space-between">
                <span style="
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                letter-spacing: 0.008em;
                text-transform: uppercase;
                color: #666666;
              ">How to Interpret the Report? </span>
              </div>
              <!-- 1 -->
              <div class="row" style="
              border: 1px solid rgba(0, 0, 0, 0.17);
              background: #fafbfd;
              border-radius: 8px;
              margin: 25px 0;
              padding: 15px;
            ">
                <h1 style="font-weight: 500; font-size: 16px; color: #292e34"> When interpreting the results, it is
                  important to remember that the scores are not good or bad, only more or less appropriate to certain
                  types of work. Since the results are based on one's own view of behavior, the accuracy of the results
                  depends upon both honesty and self-awareness while taking the test. This assessment measures
                  work-relevant personality traits that might be manifested in work behaviour and therefore influence
                  success on the job. To best use this report: </h1>
                <ul style="margin-left: 25px; color: #666666; margin-top: 15px">
                  <li style="margin-top: 15px"> Review the overall recommendation first. Based on your need, you might
                    want to prioritize candidates who are ‘recommended', followed by those who are ‘cautiously
                    recommended’. </li>
                  <li style="margin-top: 2px"> If you’re choosing among different candidates within the same band of
                    recommendation, review the competencies’ results. Focus on the competencies you believe are critical
                    for success in the role you’re hiring for, and use those scores to help you prioritize which
                    candidates to select for the next step. </li>
                  <li style="margin-top: 2px"> Remember: This assessment is just one piece of the puzzle. While hiring,
                    it is recommended that you review other information as well –functional and job knowledge,
                    background and past behaviour (e.g. using structured behavioural interviews), reference checks, etc.
                    in addition to the personality assessment. </li>
                </ul>
              </div>
            </div>
            <!-- response style -->
            <div class="Report_basic_info_area my-4" v-if="GenuineData?.responseStyles?.length != 0 &&
              GenuineData?.responseStyles != null
            ">
              <div style="margin-top: 25px;">
                <div class="Report_basic_info_heading">
                  <h4> Response Style <span :class="[GenuineData.genuineness === 'This Assessment is Genuine' ? 'Recommended_heading_text ms-3' :
                    'Not_recommended_heading_text ms-3']">
                      {{ GenuineData.genuineness }}
                    </span>
                  </h4>
                </div>
                <p style="
                  font-style: italic;
                  font-weight: 400;
                  font-size: 16px;
                  color: #666666;
                  margin-bottom: 10px;
                "> Refers to the tendency of the candidate to respond to questions in a particular way. </p>
              </div>
              <div style="
                border: 1px solid rgba(0, 0, 0, 0.17);
                padding: 25px;
                border-radius: 10px;
                margin: 30px 0;
              ">
                <div class="row border-bottom mb-4">
                  <div class="table-responsive mt-3 Attempt_Details_table_area" style="border: none !important;">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col" class="response-table-headers" v-for="item in GenuineData?.responseStyles"
                            :key="item">
                            {{ item.competencyName }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td v-for="item in GenuineData?.responseStyles" :key="item">
                            <div scope="row"
                              :class="[item.fitment === 'Genuine' ? 'text-muted' : 'show-not-genuine-fitment']">
                              {{ item.percentage }}
                              <span>({{ item.fitment }})</span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div style="margin-top: 20px">
                  <span style="
                    padding: 6px 20px;
                    background-color: #f1f0ff;
                    border-radius: 8px;
                    margin: 30px 0 15px;
                  "> Definitions </span>
                  <div class="row my-4" v-for="item in this.GenuineData?.responseStyles" :key="item">
                    <div class="col-2" style="
                      color: #7b818d;
                      flex: 0 0 auto;
                      font-weight: 500;
                      width: 16.66666667%;
                    ">
                      {{ item.competencyName }}
                    </div>
                    <div class="col-1 text-end">-</div>
                    <div class="col-8" style="flex: 0 0 auto; width: 66.66666667%">
                      <p style="color: #666666; font-weight: 400">
                        {{ item.definition ? item.definition : "NA" }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Overall Cognitive Fitment -->
            <div style="margin-top: 25px;page-break-before: always;">
              <div style="page-break-inside: avoid;">
                <div style="
             background: linear-gradient(89.69deg,#7c68ee 0.23%,#49ccfa 99.71%);
              border-radius: 8px;
              padding: 16px;
              color: #fafbfd;
              font-weight: 700;
              font-size: 20px;
            "> Overall Cognitive Fitment </div>
                <div style="margin: 30px 0">
                  <span style="
                  background: #f1f0ff;
                  font-weight: 500;
                  border-radius: 4px;
                  padding: 6px 12px;
                  color: #292e34;
                  width: auto;
                ">Definitions</span>
                  <p style="
                  margin-top: 10px;
                  font-style: italic;
                  font-weight: 400;
                  font-size: 16px;
                  color: #292e34;
                ">
                    {{ this.behaviouralData.definition
                      ? this.behaviouralData.definition
                      : "NA"
                    }}
                  </p>
                </div>
                <div class="row align-items-center">
                  <div class="col-10" style="flex: 0 0 auto; width: 80%">
                    <span style="
                    background: #f1f0ff;
                    font-weight: 500;
                    border-radius: 4px;
                    padding: 6px 12px;
                    color: #292e34;
                    width: auto;
                  ">Score Description</span>
                    <div class="d-flex" style="margin: 10px 0">
                      <div style="display: flex; align-items: center" v-for="item in this.score.ranges" :key="item">
                        <div style="
                        width: 15px;
                        height: 15px;
                        border-radius: 50%;
                        /* content: ; */
                        padding-right: 10px;
                      " :style="{ background: item.colorCode }"></div>
                        <div class="mx-2">
                          {{ item.rangeName }} ({{ item.minVal }}-{{ item.maxVal }})
                        </div>
                      </div>
                    </div>
                    <p style="font-weight: 400; font-size: 16px; color: #292e34">
                      {{ this.behaviouralData.comment
                        ? this.behaviouralData.comment
                        : "NA"
                      }}
                    </p>
                  </div>
                  <div class="col-2" style="flex: 0 0 auto; width: 20%;">
                    <CustomChart :score="this.score" v-if="this.show" :main="'scorepdf'"
                      :iconcolor="'transform-328deg'" />
                  </div>
                </div>


                <!-- line chart -->

                <div class="Score_Rank_chart_area linechart" style="page-break-inside: avoid;">
                  <canvas id="myChart1" style="width: 80%;height:100%; margin: 5px 0;"></canvas>
                  <!-- <img :src="this.imgDatab" style="width: 100%;height:100%; margin: 5px 0;" /> -->
                </div>

              </div>
            </div>
            <!-- end -->
            <!-- Self Score -->
            <div style="page-break-before: always;" v-for="(item, index) in this.behaviouralCompetencies" :key="index">
              <!-- Parent Self Score -->
              <div style="margin-top: 25px;margin-bottom: 5px; page-break-inside: avoid;">

                <div
                  style="background: linear-gradient(89.69deg,#7c68ee 0.23%,#49ccfa 99.71%); border-radius: 8px; padding: 16px; color: #fafbfd; font-weight: 700; font-size: 20px;">
                  {{ item.competencyName }}
                </div>
                <div style="margin: 30px 0">
                  <span
                    style=" background: #f1f0ff; font-weight: 500; border-radius: 4px; padding: 6px 12px; color: #292e34; width: auto; ">
                    Definitions
                  </span>
                  <p style="margin-top:10px;font-style:italic;font-weight:400;font-size:16px;color:#292e34">
                    {{ item.definition }}
                  </p>
                </div>
                <div class="row align-items-center">
                  <div class="col-10" style="flex: 0 0 auto; width: 80%">
                    <span style="
                    background: #f1f0ff;
                    font-weight: 500;
                    border-radius: 4px;
                    padding: 6px 12px;
                    color: #292e34;
                    width: auto;
                  ">Score Description</span>
                    <div class="d-flex" style="margin: 10px 0">
                      <div style="display: flex; align-items: center" v-for="(subItem) in this.subScore[index].ranges"
                        :key="subItem">
                        <div style="
                        width: 15px;
                        height: 15px;
                        border-radius: 50%;
                        /* content: ; */
                        padding-right: 10px;" :style="{ background: subItem.colorCode }"></div>
                        <div class="mx-2">{{ subItem.rangeName }} ({{ subItem.minVal }}-{{ subItem.maxVal }})</div>
                      </div>
                    </div>
                    <p style="font-weight: 400; font-size: 16px; color: #292e34">
                      {{ item.comment }}
                    </p>
                  </div>
                  <div class="col-2" style="flex: 0 0 auto; width: 20%">
                    <CustomChart :score="subScore[index]" v-if="subShow[index]" :main="item.competencyName + 'pdf'"
                      :iconcolor="'transform-328deg'" />
                  </div>
                </div>
              </div>
              <div style="margin: 15px" v-if="item.keyFocusArea">
                <span style="
                  background: #f1f0ff;
                  font-weight: 500;
                  border-radius: 4px;
                  padding: 6px 12px;
                  color: #292e34;
                  width: auto;page-break-inside: avoid;
                ">Key Focus Area</span>
                <div style="margin-top: 5px;padding-bottom: 5px;" v-if="item.keyFocusArea != null">
                  <span style="font-size: 4px;"> Key Focus Area </span>
                  <div style="margin-top: 5px;">
                    <ul class="StepProgress1">
                      <li class="StepProgress1-item is-done" style="font-size: 4px;padding-bottom: 5px;"
                        v-for="focus in item.keyFocusArea" :key="focus">
                        {{ focus }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Child Self Control -->
              <div style="margin-top: 25px;" v-for="(data, idx) in item.competencyTraits" :key="idx">
                <div style="page-break-inside: avoid;">
                  <div class="row" style="border: 1px solid rgba(0, 0, 0, 0.17); border-radius: 8px;">
                    <div class="col-md-3" style="
                  flex: 0 0 auto;
                  width: 25%;
                  background: #f9fafd;
                  padding-top: 25px;
                  border-bottom-left-radius: 8px;
                  border-top-left-radius: 8px;
                ">
                      <h3 style="
                    font-style: normal;
                    font-weight: 700;
                    font-size: 20px;
                    margin-bottom: 20px;
                  ">
                        {{ item.competencyName }}
                      </h3>
                      <div v-for="(list, id) in item.competencyTraits" :key="id">
                        <h5 style="
                      font-family: 'DM Sans';
                      font-style: normal;
                      font-weight: 700;
                      font-size: 16px;
                      color: #7c68ee;
                      padding-left: 15px;
                    " v-if="idx == id">
                          {{ list.competencyName }}
                        </h5>
                        <h5 style="
                      font-family: 'DM Sans';
                      font-style: normal;
                      font-weight: 700;
                      font-size: 16px;
                      color: #292e34;
                      padding-left: 15px;
                    " v-else>
                          {{ list.competencyName }}
                        </h5>
                      </div>
                    </div>
                    <div class="col-md-8" style="flex: 0 0 auto; width: 66.66666667%">
                      <div style="margin-top: 25px">
                        <div style="font-weight: 700; font-size: 24px; color: #292e34">
                          {{ data.competencyName }}
                        </div>
                        <div class="row" style="margin: 20px 0;">
                          <div class="col-md-10" style="flex: 0 0 auto;width: 80%">
                            <span style="
                        background: #f1f0ff;
                        font-weight: 500;
                        border-radius: 4px;
                        padding: 6px 12px;
                        color: #292e34;
                        width: auto;
                      ">Definitions</span>
                            <p style="
                        margin-top: 10px;
                        font-style: italic;
                        font-weight: 400;
                        font-size: 16px;
                        color: #292e34;
                      ">
                              {{ data.definition }}
                            </p>
                          </div>
                          <div class="col-md-2" style="flex: 0 0 auto; width: 20%">
                            <CustomChart :score="data.scoreMain" v-if="data.show" :main="data.competencyName + 'pdf'"
                              :iconcolor="'transform-328deg'" />
                          </div>
                        </div>
                        <div class="row">
                          <div style="flex: 0 0 auto; width: 100%">
                            <span style="
                          background: #f1f0ff;
                          font-weight: 500;
                          border-radius: 4px;
                          padding: 6px 12px;
                          color: #292e34;
                          width: auto;
                        ">Score Description</span>
                            <div class="d-flex" style="margin: 10px 0;flex-wrap: wrap; flex-direction: row;">
                              <div style="display: flex; align-items: center" v-for="subItem in data.scoreMain.ranges"
                                :key="subItem">
                                <div style="
                              width: 15px;
                              height: 15px;
                              border-radius: 50%;
                              background-color: #fd71ae;
                              /* content: ; */
                              padding-right: 10px;
                            " :style="{ background: subItem.colorCode }"></div>
                                <div class="mx-2">{{ subItem.rangeName }}({{ subItem.minVal
                                  }}-{{ subItem.maxVal }})</div>
                              </div>
                            </div>
                            <p style="
                          font-weight: 400;
                          font-size: 16px;
                          color: #292e34;
                        ">
                              {{ data.comment }}
                            </p>
                          </div>
                        </div>
                        <div style="margin: 15px" v-if="data.keyFocusArea">
                          <span style="
                        background: #f1f0ff;
                        font-weight: 500;
                        border-radius: 4px;
                        padding: 6px 12px;
                        color: #292e34;
                        width: auto;
                      ">Key Focus Area </span>
                          <div class="Overall_Cognitive_detail_list mt-4">
                            <ul class="list p-0">
                              <li class="list-item" v-for="focus in data.keyFocusArea" :key="focus">
                                <span class="list-item-title">
                                  {{ focus }}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--Behavioural Start-->
            <div v-if="behaviouralData.isBehaviouralInterview">
              <div style="margin-top: 25px;margin-bottom: 5px ;page-break-before: always"
                v-if="behaviouralData?.behaviouralInterviewModel != null">
                <div style="page-break-inside: avoid;">
                  <div class="Behavioural_IQ_heading_section"
                    style="font-size: 20px;background-size: contain;padding: 16px 0;border-radius: 3px;background:#7C68EE;color: white;">
                    Behavioural Interview Questions </div>
                  <div class="Report_basic_info_heading" style="margin-top: 5px;">
                    <h4 style="font-weight: 700;color: #666666;margin-top: 10px;font-size: 24px;">SUGGESTIONS FOR THE
                      RECRUITER</h4>
                    <p style="font-style: italic; font-weight: 400; font-size: 16px">Includes some rules to be kept in
                      mind while interviewing the candidates such as how to observe the candidate, avoidance of
                      environmental distractions, etc. </p>
                  </div>
                  <!-- suggestedScript -->
                  <div class="Report_basic_info_area" style="margin: 25px 0;"
                    v-if="this.behaviouralData?.behaviouralInterviewModel?.suggestedScript">
                    <div class="row" style="
              border: 1px solid rgba(0, 0, 0, 0.17);
              border-radius: 8px;
              margin: 25px 0;
              padding: 15px;
            ">
                      <span style="
                background: #f1f0ff;
                font-weight: 500;
                border-radius: 4px;
                padding: 6px 12px;
                color: #292e34;
                width: auto;
              ">Suggested Script</span>
                      <p style="font-style: italic; font-weight: 400; font-size: 16px;margin-top: 5px"> Includes
                        conversational pointers for the recruiters to refer while interviewing the candidates. </p>
                      <div v-for="itemlist in this.behaviouralData
                        ?.behaviouralInterviewModel?.suggestedScript" :key="itemlist">
                        <ul class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Pointer'">
                          <li class="my-2">
                            {{ itemlist.content }}
                            <div v-for="dependentText in itemlist?.dependentTexts" :key="dependentText">
                              <ol v-if="dependentText.textType == 'Pointer'">
                                <li>
                                  {{ dependentText?.content }}
                                </li>
                              </ol>
                              <span v-html="dependentText.content" v-if="dependentText.textType == 'Html'"></span>
                              <div class="mt-3 text-muted font-size-17" v-if="dependentText.textType == 'Paragraph'">
                                <p class="my-2">
                                  {{ dependentText.content }}
                                </p>
                              </div>
                            </div>
                          </li>
                        </ul>
                        <span v-html="itemlist.content" v-if="itemlist.textType == 'Html'"></span>
                        <div class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Paragraph'">
                          <p class="my-2">
                            {{ itemlist.content }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- basicGuidelines -->
                <div class="Report_basic_info_area my-1" style="margin: 5px 0;page-break-inside: avoid;"
                  v-if="this.behaviouralData?.behaviouralInterviewModel?.basicGuidelines">
                  <div class="row" style="
              border: 1px solid rgba(0, 0, 0, 0.17);
              border-radius: 8px;
              margin: 25px 0;
              padding: 15px;
            ">
                    <div>
                      <span style="
                background: #f1f0ff;
                font-weight: 500;
                border-radius: 4px;
                padding: 6px 12px;
                color: #292e34;
                width: auto;
              ">Basic Guidelines</span>
                      <p
                        style="font-family: 'DM Sans';font-style: italic;font-weight: 400;font-size: 16px;margin-top: 5px;">
                        Includes some rules to be kept in mind while interviewing the candidates such as how to observe
                        the candidate, avoidance of environmental distractions, etc. </p>
                      <div v-for="itemlist in this.behaviouralData
                        ?.behaviouralInterviewModel?.basicGuidelines" :key="itemlist">
                        <ul class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Pointer'">
                          <li class="my-2">
                            {{ itemlist.content }}
                            <div v-for="dependentText in itemlist?.dependentTexts" :key="dependentText">
                              <ol v-if="dependentText.textType == 'Pointer'">
                                <li>
                                  {{ dependentText?.content }}
                                </li>
                              </ol>
                              <span v-html="dependentText.content" v-if="dependentText.textType == 'Html'"></span>
                              <div class="mt-3 text-muted font-size-17" v-if="dependentText.textType == 'Paragraph'">
                                <p class="my-2">
                                  {{ dependentText.content }}
                                </p>
                              </div>
                            </div>
                          </li>
                        </ul>
                        <span v-html="itemlist.content" v-if="itemlist.textType == 'Html'"></span>
                        <div class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Paragraph'">
                          <p class="my-2">
                            {{ itemlist.content }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- aboutBehaviouralInterview -->
                <div class="Report_basic_info_area my-1"
                  v-if="this.behaviouralData?.behaviouralInterviewModel?.aboutBehaviouralInterview">
                  <div class="row" style="
              border: 1px solid rgba(0, 0, 0, 0.17);
              border-radius: 8px;
              margin: 25px 0;
              padding: 15px;page-break-inside: avoid;
            ">
                    <div>
                      <span style="
                background: #f1f0ff;
                font-weight: 500;
                border-radius: 4px;
                padding: 6px 12px;
                color: #292e34;
                width: auto;
              ">About Behavioural Interview</span>
                      <p
                        style="font-family: 'DM Sans';font-style: italic;font-weight: 400;font-size: 16px;margin-top: 5px;">
                        Includes some rules to be kept in mind while interviewing the candidates such as how to observe
                        the candidate, avoidance of environmental distractions, etc. </p>
                      <div
                        v-for="(itemlist) in this.behaviouralData?.behaviouralInterviewModel?.aboutBehaviouralInterview"
                        :key="itemlist">
                        <ul class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Pointer'">
                          <li class="my-2">
                            {{ itemlist.content }}
                            <div v-for="dependentText in itemlist?.dependentTexts" :key="dependentText">
                              <ol v-if="dependentText.textType == 'Pointer'">
                                <li>
                                  {{ dependentText?.content }}
                                </li>
                              </ol>
                              <span v-html="dependentText.content" v-if="dependentText.textType == 'Html'"></span>
                              <div class="mt-3 text-muted font-size-17" v-if="dependentText.textType == 'Paragraph'">
                                <p class="my-2">
                                  {{ dependentText.content }}
                                </p>
                              </div>
                            </div>
                          </li>
                        </ul>
                        <span v-html="itemlist.content" v-if="itemlist.textType == 'Html'"></span>
                        <div class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Paragraph'">
                          <p class="my-2">
                            {{ itemlist.content }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- BIQ Question Start -->
              <div v-if="this.isBehaviouralInterview">
                <div style="margin-top:25px;" v-for="(item, index) in this.behaviouralCompetencies" :key="index">
                  <div style="page-break-inside: avoid;" class="Overall_Cognitive_section border_radius_Hp my-4"
                    v-if="item?.interviewQuestions != undefined && item?.interviewQuestions != null && item?.interviewQuestions?.length != 0">
                    <div style=" border: 1px solid #dbdbdb;border-radius: 3px;">
                      <div
                        style="background-color: rgb(124, 104, 238);border-radius: 2px;padding: 8px;color: rgb(250, 251, 253);font-weight: 700;font-size: 20px;">
                        {{ item.competencyName }}
                      </div>
                      <div class="row" style="margin: 30px 0">
                        <div class="col-md-10" style="flex: 0 0 auto; width: 67%">
                          <span style="
                    background: #f1f0ff;
                    font-weight: 500;
                    border-radius: 4px;
                    padding: 6px 12px;
                    color: #292e34;
                    width: auto;
                  "> Definition</span>
                          <p style="
                    font-weight: 400;
                    font-style: italic;
                    font-size: 16px;
                    color: #292e34;
                    margin-top: 15px;
                  ">
                            {{ item.definition }}
                          </p>
                        </div>
                        <div class="col-md-2" style="flex: 0 0 auto; width: 33%">
                          <CustomChart :score="subScore[index]" v-if="subShow[index]"
                            :main="item.competencyName + '_' + index + 'pdf'" :iconcolor="'transform-328deg'" />
                        </div>
                      </div>
                      <div style="margin: 5px 0; padding:0 3px">
                        <span style="
                background: #f1f0ff;
                font-weight: 500;
                margin: 15px;
                border-radius: 4px;
                padding: 6px 12px;
                color: #292e34;
                width: auto;
              ">Questions</span>
                        <div v-for="(Questions, index) in item.interviewQuestions" :key="Questions" style="
                border: 1px solid rgba(0, 0, 0, 0.17);
                border-radius: 8px;
                margin: 25px 0;
                padding: 15px;
                margin: 15px;
              ">
                          <p>
                            {{ index + 1 }}. {{ Questions.content }}
                          </p>
                          <ul v-for="Question in Questions.dependentTexts" :key="Question"
                            style="font-style: normal; font-weight: 400; font-size: 16px">
                            <li>{{ Question.content }}</li>
                          </ul>
                          <div style="background: #f8f7ff; padding: 12px; border-radius: 4px">
                            <h4 style="
                    font-weight: 500;
                    font-size: 20px;
                    color: #4b2eee;
                    margin-bottom: 15px;
                  "> Positive Indicator </h4>
                            <ul class="nav Recommendation_Strengths_points">
                              <li style="align-items: flex-start; margin-bottom:4px;" class="mb-3"
                                v-for="Positive in Questions.positiveIndicator" :key="Positive">
                                <img style="margin-right:3px"
                                  src="../../public/dashboard-assets/images/M7/Behavioural_Page_P_Icon.png" width="20"
                                  height="20" alt="" />
                                <span style="font-size: 16px;line-height: 1;">{{ Positive.content }}</span>
                              </li>
                            </ul>
                          </div>
                          <div style="background: #fff7fb; padding: 10px;
                  border-radius: 3px; margin-top: 5px;">
                            <h4 style="
                    font-weight: 500;
                    font-size: 20px;
                    color: #4b2eee;
                    margin-bottom: 15px;
                  "> Negative Indicator </h4>
                            <ul class="nav Recommendation_Improvements_points">
                              <li style="align-items: flex-start; margin-bottom:4px;" class="mb-3"
                                v-for="Negative in Questions.negativeIndicator" :key="Negative">
                                <img src="../../public/dashboard-assets/images/M7/Behavioural_Page_N_Icon.png"
                                  width="20" height="20" alt="" style="margin-right:3px" />
                                <span style="font-size: 16px;line-height: 1;">{{ Negative.content }}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <!-- Managerial Recommendation -->
            <div v-if="behaviouralData.isManagerialCounsel">
              <div class="Behavioural_IQ_heading_section" style="margin-top:25px; background-size: contain;background:#7C68EE;font-size: 20px;color: white;padding: 16px;
    border-radius: 3px; margin-bottom:5px;page-break-before: always;"> Managerial Recommendation </div>
              <div class="Overall_Cognitive_section " style="border: 1px solid rgba(0, 0, 0, 0.17);border-radius: 3px;">
                <div v-for="Managerial in behaviouralCompetencies" :key="Managerial">
                  <span v-if="Managerial.managerialRecommendation != null">
                    <span v-if="Managerial.managerialRecommendation.length != 0">
                      <div style="page-break-inside: avoid;">
                        <div class="Overall_Cognitive_header"
                          style="background-color: rgb(124, 104, 238);border-radius: 2px;  padding: 4px;    color: rgb(250, 251, 253);    font-weight: 700;    font-size: 20px;">
                          {{ Managerial.competencyName }}
                          <span style="background: rgb(255, 255, 255);padding: 2px 3px;color: rgb(253, 113, 175);font-weight: 500;font-size: 16px;
    border: 0.1px solid rgb(253, 113, 174);border-radius: 20px;">{{ Managerial.fitment }}</span>
                        </div>
                        <div class="row" style="margin: 30px 0">
                          <div>
                            <span style="
                      background: #f1f0ff;
                      font-weight: 500;
                      border-radius: 4px;
                      padding: 6px 12px;
                      color: #292e34;
                      width: auto;
                    "> Definition </span>
                            <p style="
                      font-weight: 400;
                      font-style: italic;
                      font-size: 16px;
                      color: #292e34;
                      margin-top: 15px;
                    ">
                              {{ Managerial.definition }}
                            </p>
                          </div>
                          <div style="margin-top:15px;">
                            <ul class="StepProgress" style="font-style: normal;
                      font-weight: 400;
                      font-size: 16px;
                      margin-left: 20px;">
                              <li class="StepProgress-item is-done"
                                v-for="(Manageriallist) in Managerial.managerialRecommendation" :key="Manageriallist">
                                {{ Manageriallist }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <!-- DISCLAIMER -->
            <Disclaimer></Disclaimer>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import CustomChart from "./CustomChart.vue";
import Disclaimer from "./report/partial-view/Disclaimer.vue";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
import * as html2pdf from "html2pdf.js";
import store from "../store";
//import html2canvas from "html2canvas";
import Base64Images from "../utils/base64Image.js";
import { SetClarityData } from "../platformFeatures/featureUtils.js";
export default {
  name: "BehaviouralPDF",
  // props: ['testId', 'candidateId', 'name'],
  data() {
    return {
      candidateId: window.atob(this.$route.query.candidateId),

      // candidateId: 10104,
      BasicInfoData: [],
      genuineData: [],
      behaviouralData: [],
      behaviouralCompetencies: [],
      show: false,
      score: {},
      subScore: [],
      subShow: [],
      imgDatab: '',
      recommendationValue: "",
      color_recommendation: '',
      recommendation_img: "",
      namePdf: "",
      testNamePDF: "",
      Companylogo: "",
      isBehaviouralInterview: "",
    };
  },
  components: {
    CustomChart,
    Disclaimer,
  },
  async created() {
    this.moment = moment;
    await this.getInfo();
    await this.GetBehaviouralData();
    await this.lineChart();
    await this.genuineResponse();
    await this.GetScoreRank();
    // const canvas = document.getElementById('linechart');
    // setTimeout(async () => {
    //   this.imgDatab = (await html2canvas(canvas)).toDataURL("image/png");
    // }, 1000);
    await this.callPDfFunction();

  },
  mounted() {
    SetClarityData();
  },
  methods: {
    ...mapActions(["getBasicInfo", "GetGenuineModel", "getBehaviouralData", "GetScoreRankData"]),

    async getInfo() {
      var info = await this.getBasicInfo(this.candidateId);
      if (info?.status) {
        this.BasicInfoData = info.object.data;
        this.Companylogo = this.BasicInfoData.companyLogo;
        this.namePdf = this.BasicInfoData.name;
        this.testNamePDF = this.BasicInfoData.testName;
      } else {
        this.BasicInfoData = null;
      }
    },

    async genuineResponse() {
      var GenuineData = await this.GetGenuineModel(this.candidateId);
      if (GenuineData?.status) {
        this.GenuineData = GenuineData.object.data;
      } else {
        this.GenuineData = "";
      }
    },

    async GetBehaviouralData() {
      var response = await this.getBehaviouralData(this.candidateId);
      this.behaviouralData = response.object.data;
      this.isBehaviouralInterview =
        response.object.data.isBehaviouralInterview;
      this.score = {
        marksScored: this.behaviouralData.score,
        outOfMarks:
          this.behaviouralData?.ranges[
            this.behaviouralData?.ranges.length - 1
          ].maxVal,
        result: this.behaviouralData.fitment,
        ranges: this.behaviouralData.ranges,
      };
      this.show = true;
      this.behaviouralCompetencies = this.behaviouralData.competencies;

      /*main*/
      this.behaviouralCompetencies.forEach((element, index) => {
        /*max val*/
        var arr = [];
        element.ranges.forEach((el) => {
          arr.push(el.maxVal);
        });
        var max = [0];
        for (var i = 0; i < arr.length; i++) {
          if (max < arr[i]) {
            max = arr[i];
          }
        }

        this.subShow[index] = false;
        var score = {
          marksScored: element.score,
          outOfMarks: max,
          result: element.fitment,
          ranges: element.ranges,
        };
        this.subScore[index] = score;
        this.subShow[index] = true;

        /*parameter*/
        element.competencyTraits.forEach((elm) => {
          var ar = [];
          element.ranges.forEach((el) => {
            ar.push(el.maxVal);
          });
          var mx = Math.max.apply(null, ar);
          elm.show = false;
          var score = {
            marksScored: element.score,
            outOfMarks: mx,
            result: element.fitment,
            ranges: element.ranges,
          };
          elm.scoreMain = score;
          elm.show = true;
        });
      });

    },
    async lineChart() {
      var labels = [];
      var score = [];
      this.behaviouralCompetencies.forEach((elm) => {
        labels.push(elm.competencyName);
        score.push(elm.score);
      });
      var ctx = document.getElementById("myChart1").getContext("2d");
      var chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Low (0-4)",
              data: score,
              pointBackgroundColor: " #FFFFFF",
              backgroundColor: "rgba(255, 175, 210, 0.29)",
              pointBorderColor: [],
              pointHitRadius: 1,
              borderWidth: 1,
              pointRadius: 5,
            }, {
              label: "Average (4-7)",
              data: [],
              pointBackgroundColor: " #FFFFFF",
              backgroundColor: " rgba(255, 236, 166, 0.3)",
              pointBorderColor: [],
              pointHitRadius: 1,
              borderWidth: 1,
              pointRadius: 5,
            }, {
              label: "High (7-10)",
              data: [],
              pointBackgroundColor: " #FFFFFF",
              backgroundColor: "rgba(124, 104, 238, 0.1)",
              pointBorderColor: [],
              pointHitRadius: 1,
              borderWidth: 1,
              pointRadius: 5,
            },
          ],

        },
        options: {
          width: 350,
          height: 400,
          indexAxis: "y",
          scales: {
            y: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Competencies",
              },
            },
            x: {
              beginAtZero: true,
              suggestedMin: 0,
              suggestedMax: 10,
              title: {
                display: true,
                text: "Score",
              },
            },
          },
          plugins: {
            customPlugin: {
              consoleText: "testText",
            },
            legend: {
              display: true,
            },
          },
        },
        plugins: [
          {
            id: "customPlugin",
            beforeDraw: (chart) => {
              const {
                ctx,
                chartArea: { top, height },
                scales: { x },
              } = chart;
              ctx.fillStyle = "rgba(255, 175, 210, 0.29)";
              ctx.fillRect(
                x.getPixelForValue(0),
                top,
                x.getPixelForValue(4) - x.getPixelForValue(0),
                height
              );
              ctx.fillStyle = "rgba(255, 236, 166, 0.3)";
              ctx.fillRect(
                x.getPixelForValue(4),
                top,
                x.getPixelForValue(7) - x.getPixelForValue(4),
                height
              );
              ctx.fillStyle = "rgba(124, 104, 238, 0.1)";
              ctx.fillRect(
                x.getPixelForValue(7),
                top,
                x.getPixelForValue(10) - x.getPixelForValue(7),
                height
              );
            },
          },
        ],
      });
      for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
        if (
          chart.data.datasets[0].data[i] <= 4 &&
          chart.data.datasets[0].data[i] >= 0
        ) {
          chart.data.datasets[0].pointBorderColor.push("#FD71AE");
        }
        if (
          chart.data.datasets[0].data[i] <= 7 &&
          chart.data.datasets[0].data[i] > 4
        ) {
          chart.data.datasets[0].pointBorderColor.push("#FFC801");
        }
        if (
          chart.data.datasets[0].data[i] <= 10 &&
          chart.data.datasets[0].data[i] > 7
        ) {
          chart.data.datasets[0].pointBorderColor.push(" #7C68EE");
        }
      }
      chart.update();

      //  const canvas = document.getElementById('myChart1');
      //   //this.imgDatab = (await html2canvas(canvas)).toDataURL("image/png");
      //   setTimeout(async () => {
      //     this.imgDatab = (html2canvas(canvas)).toDataURL("image/png");
      //   }, 1000);
    },

    async GetScoreRank() {
      var Rank = await this.GetScoreRankData(this.candidateId);
      this.recommendationValue = Rank?.object?.data?.testRecommendation;
    },

    getRecommendationClass() {
      if (this.recommendationValue === "This Assessment is Recommended.") {
        this.recommendation_img = "data:image/png;base64,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";
        return "recommended";
      } else if (this.recommendationValue === "This Assessment is not Recommended.") {
        this.recommendation_img = "data:image/png;base64,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";
        return "recommended_not";
      } else if (this.recommendationValue === "") {
        this.recommendation_img = "data:image/png;base64,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";
        return "recommended_null";
      } else {
        this.recommendation_img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAX9SURBVHgBzVfPbxtFFH4zs2s7zpLYKU1pVNR1e0CISklA4orbAzdET3BsI/Ej4kBTVCEhISXcuCBSpEpwaor4A1r1xoGEVoDopaZV2wNq6kARcqM0dtrEWXtnhvdmdtdO49oJF3jSxJv17Hzf+96vNcB/bAz+hS3++tGoEmyWcVYUQoAQfCFs6onC+Odl2KVx2KXdvXb6lBKwkIBzAZzz1zJ9qcXK759Nwy6tqwI3r75TBBCjnIu867iDmrHj6K3PGCdQsN4bAtEy/5dxXeTCqeK+GihY8A6cLu2aQOnKu+cF4yc5jwBiIOGg10zjfWa8F+3gjo7IMCSho2cZPjvr7vngdCcc3tnz96Z5DC645jbOmg5F8JbX9B2PgFpKMAssYpU0Z2xKrn4z0wnLgY66sFPoX3wos4AMHEcwr59BJg3MdfF/YRWUkqHSjD6ZVMKCIio3n5zOw13qQ/wz0zMEN69OFjHB5gW3XjOSGgn0Zzk8O8SAu4cBMq8AuIdQv5x9SFZwLQM074Ju3IMQSWDuGCIMTWsFWinYlI1xb3hrPjjbnWdjsaQsknMP4gwM5gG8tyzwkyb22ZU6AqxvDdz1S6DkugkBgiO2YqClFhqO4+7SUxW4Pj/pZzLuPOL6Vj7BhgYZ5IZGAAYncXcGdmQ6AP34MshmBTASWmJslJL4harWNxrj+cIn5XgrfxIc5fejDGYDHoLnh3YHbtzCJPHegDBMQaMRYAgk0EIiOeHC/Oq9GX8LgXZwh8Bt1kNuAAUaeL83+J2j2B4ntpFwBl6HjfUaAoeUA5rCgRc+5RiSyCUEMn3uNLeeYw6gaLg8TDonewRjm4eeFpQBli9su+1kDmK5jMBm/RFQHlAYzJLKD1U4lRDAZBlLGo5jazibRe9TL3UHDqsAS9hfgiWA/tGOW9LeGBLYQOAQgSXTyoRD48UJQ9KoxXmOMw6tBsLAFUjAGYGuXpP0BE6WHQN4tGCvUz4i+/ay/zASeAz93qDJA1QCbFXoaqKAa3p31LnMcsBx8SvxXAvw4SUsoIKVem1hKzgZ3b99zK47x5LbTmoPBIFVwJakVUDJsJQQwG1nbdvkOm6x1Ei2WGXWAqYP2oRrB++kTps1w8B4TuVITQlzgKXSaiYhQHOcM+cidT3GzYhlSiMBVWudsvEbVkQRO16tOziZyCWX9cdloPBaz6kjSq1BzeUPfbGUEDAaOOySg+BUhpgTQD0dmn+0Dg2r0ecq9LT8my3ea4vUXQ04kZBKMlTix/j71jQUpv1qKkFUALsXEmjcbh1K0pO0UXJ1tf2nksuVyk+QzvRTBYCpAFwCmnobAax+345SkwtGAR3+hR7ftxv2TVkCDso7tgjw4g8Ae09YYu12YNpWBFpQr0DtwTXwvByg7LYHYC40pPbj7ckw4pj5phJQLpsLHELJwa0jkPe29arNM6ME5cRTLAzX4dYvZyA/NAxRK9b2kxqSYtsUcBx3lWKVNCSa4ygWTTVYv2wGzE7NgP98BrLYwcl7U/taJd0QU/LeNgKg3AsY+6qIXiJokQqYEVo1lyFY+Q4naq0n+NrDG3DjyiQ4+Do4mB+OPA815YCtBF1Wm40kCbeM40blq1EFgOXIo4nIKX1NBjebgelo4PrgZl8AJ70fUn0HzHPNzQfwaPUWPPjze6itlGDv8PPYygdszLVNPFJBKywlGR4tvDpX6kiArP73l77rpoqYD9MYkoNUNtq0z9DIGNTXzXAJgjrU62tIrAFEkvLHTaXhGS9njiWvJUoePVvFO7OYfmcL43PVdryur+XhyrnzKNlJ0zoVvVRERMgb45mK7kdTjl46cK8FtkkXSvUtztupwvhstRNGz19GjeWz1xFwFIFZFEMLKmU0XCwQtdfYayIIdC3Vkj/+daHb+T1/GTV0MKGiMBg5ZUwk9loRGUaxjiXXduazlBbFXuf3JOANf1zCIXYchS0rW8dRVwvLCDWHnxeRSJkkj8NAyYY8JkZePrfU6/wd/ziNXqGK5r0um57Pj3y65fD716fGFIS+BExKyC48Leb/O/sHSTJKiss5KzoAAAAASUVORK5CYII=";
        return "recommended_default";
      }

    },
    async callPDfFunction() {
      store.state.loader.isLoading = true;

      const namePdf = this.namePdf;
      const testName = this.testNamePDF;
      // const Companylogo = this.Companylogo;
      // const clientCompany = this.clientCompany;
      var opt = {
        margin: [23, 1, 20, 1],
        filename: `Behavioural_${namePdf}`,
        html2canvas: { scale: 3, dpi: 192, letterRendering: true, useCORS: true },
        pagebreak: { mode: "css" },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };
      /*header*/
      const headerContent = `
      <section class="container-fluid" style="padding: 15px 20px; background: linear-gradient(132deg, #F2F5F0 37.25%, #E8F7FF 85.4%); margin-botton:10px">
      <div style="display: flex; justify-content: space-between">
        <span>
          <img src="`+ Base64Images.PMapsLogo + `" alt="" />
        </span>
        <span style="font-size: 18px;
        font-weight: 500; padding: 10px 15px;">
        `+ testName + `
        </span>
        <span>
          <img src="`+ Base64Images.PMapsLogo2 + `" alt="" />
        </span>
      </div>
    </section>`;

      const headerContent1 = `
      <section class="container-fluid topPDF" style="padding: 20px 25px;">
      <div style="display: flex; justify-content: space-between">
        <span>
          <img src="`+ Base64Images.PMapsLogo + `" alt="" />
        </span>
        <span>
          <img src="`+ Base64Images.PMapsLogo2 + `" alt="" />
        </span>
      </div>
      </section>`;

      /*footer*/
      const footerContent = `<section class="container-fluid footerPDF" style="padding: 20px 25px"></span></section>`;


      html2pdf()
        .from(headerContent1)
        .toImg()
        .get("img")
        .then((image) => {
          html2pdf()
            .from(headerContent)
            .toImg()
            .get("img")
            .then((img) => {
              html2pdf()
                .from(footerContent)
                .toImg()
                .get("img")
                .then((ig) => {
                  html2pdf()
                    .from(document.getElementById("behaviour"))
                    .set(opt)
                    .toPdf()
                    .get("pdf")
                    .then((pdf) => {
                      var totalPages = pdf.internal.getNumberOfPages();
                      for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        if (i != 1) {
                          pdf.addImage(
                            img,
                            "JPEG",
                            0,
                            0,
                            pdf.internal.pageSize.getWidth(),
                            0
                          );
                        } else {
                          pdf.addImage(
                            image,
                            "JPEG",
                            0,
                            0,
                            pdf.internal.pageSize.getWidth(),
                            0
                          );
                        }
                        pdf.addImage(
                          ig,
                          "JPEG",
                          0,
                          pdf.internal.pageSize.getHeight() - 23,
                          pdf.internal.pageSize.getWidth(),
                          0
                        );
                        pdf.setFontSize(15);
                        pdf.setTextColor(100);
                        pdf.text(
                          "Behavioural " + "|" + i,
                          pdf.internal.pageSize.getWidth() - 37,
                          pdf.internal.pageSize.getHeight() - 3
                        );
                        this.$router.push({
                          name: "ActiveTestReportBehavioural",
                          params: {
                            candidateId: this.$route.query.candidateId,
                            testId: this.$route.query.testId,

                          },
                          query: {
                            name: this.$route.query.name,
                            clientId: this.$route.query.clientId,
                            isParent: this.$route.query.isParent,
                            id: this.$route.query.id,
                            offset: this.$route.query.offset,
                            current: this.$route.query.current,
                          },
                        });

                        store.state.loader.isLoading = false;

                      }
                    })
                    .save();

                  //window.open('', '_self', ''); window.close();
                });
            });

        });

    },
  },
};
</script>

<style scoped>
.Behavioural_Interview {
  background-image: url(../../public/dashboard-assets/images/M7/Badge_Heading_bg.png);
  text-align: center;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: 10px;
  margin: 0;
  padding: 14px 0;
  color: #7c68ee;
  font-size: 20px;
  font-weight: 700;
}

.linechart canvas {
  height: 500px !important;
  width: 100% !important;
}
</style>
